import React, { useState, useEffect } from "react";
import { Container, Alert, Row, Col, Form } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { Large } from "../../stories/Button.stories";
import AuthService from "../../services/auth.service";
import InputGroup from "react-bootstrap/InputGroup";
import UserService from "../../services/user.service";
import ToastBlockContainer from "../../common/ToastBlockContainer";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const SignIn = () => {
  let history = useHistory();
  const initialValues = { email: "", password: "" };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inviteExist, setinviteExist] = useState([]);
  // Initialize a boolean state
  const [passwordShown, setPasswordShown] = useState(false);
  const [successToast, setSuccessToast] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };
  // Password toggle handler
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate(formValues));
    setIsSubmit(true);
    setLoading(true);
  };

  // Abandon a login that got part-way through. Without this the cookie and the
  // partial UserDetails written by AuthService.login() survive, and the user is
  // stuck: authenticated enough to be bounced off this form, not authenticated
  // enough for any page to load.
  const failLogin = (message) => {
    AuthService.clearSession();
    setSuccessToast(false);
    setShowToast(true);
    setToastMessage(message);
    setFormErrors({ msg: message });
    setIsSubmit(false);
    setLoading(false);
  };

  useEffect(() => {
    // Redirect to the dashboard only if the session is COMPLETE. A partially
    // written UserDetails (the {message, uuid} stub written before the profile
    // call succeeds) has no `id`, which makes every downstream family lookup
    // fail - and bouncing on it locked users out of the login form entirely.
    let items = localStorage.getItem("UserDetails");
    if (items) {
      let stringify = null;
      try {
        stringify = JSON.parse(items);
      } catch (e) {
        stringify = null;
      }

      const hasCompleteSession =
        stringify && stringify.id && stringify.email && cookies.get("accessToken");

      if (hasCompleteSession) {
        history.push("/family_selection");
        return;
      }

      // Stale or half-written session: clear it so the form below is usable.
      AuthService.clearSession();
    }

    if (Object.keys(formErrors).length === 0 && isSubmit) {
      let data = {
        email: formValues.email.toLowerCase(),
        password: formValues.password,
      };
      // api call
      AuthService.login(data).then(
        (res) => {
          // profile api call
          UserService.userProfile(res.data.uuid).then(
            (response) => {
              // The login call already persisted the cookie and a {message,
              // uuid} stub. If the profile lookup did not come back with real
              // data we must undo that, or the user is left authenticated but
              // unrouted and can never reach the login form again.
              if (!response || !response.userData) {
                failLogin(
                  "We couldn't load your profile. Please try signing in again."
                );
                return;
              }

              var entry = {
                avatar: response.userData.avatar,
                countryCode: response.userData.countryCode,
                contactNumber: response.userData.contactNumber,
                createdAt: response.userData.createdAt,
                email: response.userData.email,
                firstname: response.userData.firstName,
                id: response.userData.id,
                isActive: response.userData.isActive,
                isContactVerified: response.userData.isContactVerified,
                isEmailVerified: response.userData.isEmailVerified,
                lastname: response.userData.lastName,
                updatedAt: response.userData.updatedAt,
                uuid: res.data.uuid,
                displayId: response.userData.displayId,
                //'accessToken': UserDetails.accessToken,
              };

              setSuccessToast(true);
              setShowToast(true);
              setToastMessage(
                "Signin successful. Please wait while we load your dashboard"
              );

              UserService.getImages().then((respo) => {
                console.log(respo);
                localStorage.setItem("defaultImgg", respo.defaultImgg);
                localStorage.setItem("defaultusrImgg", respo.defaultusrImgg);
                localStorage.setItem(
                  "supplierDefaultLogo",
                  respo.supplierDefaultLogo
                );
              });

              localStorage.setItem("UserDetails", JSON.stringify(entry));

              setTimeout(() => {
                var array = [];
                UserService.getUserFamilyInvite(res.data.uuid).then(
                  (response) => {
                    const invites =
                      response && Array.isArray(response.InviteData)
                        ? response.InviteData
                        : [];
                    setinviteExist(invites);
                    array.push(...invites);
                  }
                );

                UserService.getUserFamily(res.data.uuid).then((response) => {
                  if (
                    !response ||
                    !Array.isArray(response.usersFamilyData)
                  ) {
                    failLogin(
                      "We couldn't load your account. Please try signing in again."
                    );
                    return;
                  }

                  let activeFam = [];

                  for (let i = 0; i < response.usersFamilyData.length; i++) {
                    if (
                      response.usersFamilyData[i].inviteStatus ===
                        "Onboarded" &&
                      response.usersFamilyData[i].Family &&
                      response.usersFamilyData[i].Family.status === "Active"
                    ) {
                      activeFam.push(response.usersFamilyData[i]);
                    }
                  }

                  let acceptencePendingFam = [];
                  for (let i = 0; i < response.usersFamilyData.length; i++) {
                    if (
                      response.usersFamilyData[i].inviteStatus ===
                        "Acceptance Pending" &&
                      response.usersFamilyData[i].Family &&
                      response.usersFamilyData[i].Family.status === "Active"
                    ) {
                      acceptencePendingFam.push(response.usersFamilyData[i]);
                    }
                  }

                  if (
                    activeFam.length === 0 &&
                    acceptencePendingFam.length === 0
                  ) {
                    history.push({
                      pathname: "/newcard_billing_details",
                      familyList: "",
                      inviteList: "",
                    });
                  } else if (activeFam.length === 1) {
                    if (activeFam[0].isSu) {
                      history.push({
                        pathname:
                          "/support_dashboard/" + activeFam[0].Family.uuid,
                        familyList: "",
                        inviteList: "",
                      });
                    } else {
                      history.push({
                        pathname: "/dashboard/" + activeFam[0].Family.uuid,
                        familyList: "",
                        inviteList: "",
                      });
                    }
                  } else if (activeFam.length > 1) {
                    history.push({
                      pathname: "/family_selection",
                      familyList: "",
                      inviteList: "",
                    });
                  } else if (
                    activeFam.length === 0 &&
                    acceptencePendingFam.length > 0
                  ) {
                    history.push({
                      pathname: `/myInvites`,
                      familyList: "",
                      inviteList: "",
                    });
                  }
                },
                () => {
                  failLogin(
                    "We couldn't load your account. Please try signing in again."
                  );
                });
              }, 2500);
            },
            () => {
              failLogin(
                "We couldn't load your profile. Please try signing in again."
              );
            }
          );
        },
        (error) => {
          const errors = {};

          setSuccessToast(false);
          setShowToast(true);
          setToastMessage("Invalid email or password/Account is not Active");

          if (error.response === undefined) {
            errors.msg = "Connection timed out. Please try again later";
            setFormErrors(errors);
          } else {
            errors.msg = error.response.data.error;
            if (errors.msg) {
              setFormErrors(errors);
            }
          }
          setLoading(false);
        }
      );
    } else {
      setLoading(false);
    }
  }, [formErrors]);

  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!values.email && !values.password) {
      errors.msg = "Please enter a valid email address and password";
      errors.email = "Yes";
      errors.password = "Yes";
    } else {
      if (!values.email) {
        errors.msg = "Please enter a valid email address";
        errors.email = "Yes";
      } else if (!regex.test(values.email)) {
        errors.msg = "This is not a valid email format !";
        errors.email = "Yes";
      }

      if (!values.password) {
        errors.msg = "Please enter a valid password";
        errors.password = "Yes";
      } else {
        var alphanumerics = /^.{8,40}$/; // /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
        if (!values.password.match(alphanumerics)) {
          errors.msg = "Please enter a valid password";
          errors.password = "Yes";
        }
      }
    }
    return errors;
  };

  return (
    <Container>
      <ToastBlockContainer
        successToast={successToast}
        showToast={showToast}
        setShowToast={setShowToast}
        toastMessage={toastMessage}
      />
      <Row className="justify-content-center gy-0 mb-6rem">
        <Col md="18" lg="14" xl="12" xxl="10">
          <section className="bg-white p-4 p-md-5 p-lg-6 shadow rounded-4 mb-4 mb-md-6">
            <h1 className="mb-2">Sign into Elderly Life Account</h1>
            <p className="mb-4">
              Don’t have an Account yet?{" "}
              <a href="/signup" className="">
                Sign Up
              </a>
            </p>
            <Form className="login-form" onSubmit={handleSubmit}>
              {/* {Object.keys(formErrors).length !== 0 && isSubmit ? (
                <Alert className="mb-4" key="danger" variant="danger">
                  {formErrors.msg}
                </Alert>
              ) : (
                ""
              )} */}

              <Form.Group className="mb-4">
                <Form.Label className={formErrors.email ? "invalid-text" : ""}>
                  Email
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="John@gmail.com"
                  defaultValue="Mark"
                  name="email"
                  value={formValues.email}
                  onChange={handleChange}
                  className={`${formErrors.email ? `invalid-border` : ""}`}
                />
                <Form.Text className={formErrors.email ? "invalid-text" : ""}>
                  Enter your registered email address
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-4">
                <div className="d-flex align-items-end mb-1">
                  <Form.Label
                    className={formErrors.password ? "invalid-text" : ""}
                  >
                    Password
                  </Form.Label>
                  <div className="ms-auto small">
                    <Link
                      to="/forgetPassword"
                      tabindex="-1"
                      className="text-body fw-medium"
                    >
                      Forgot Password?
                    </Link>
                  </div>
                </div>
                <InputGroup
                  className={formErrors.password ? "invalid-border br-12" : ""}
                >
                  <Form.Control
                    type={passwordShown ? "text" : "password"}
                    placeholder="Password"
                    name="password"
                    value={formValues.password}
                    onChange={handleChange}
                  />
                  <InputGroup.Text onClick={togglePassword}>
                    <i
                      className={`fa ${
                        passwordShown ? "fa-eye" : "fa-eye-slash"
                      } cursor-pointer`}
                    />
                  </InputGroup.Text>
                </InputGroup>
                <Form.Text
                  className={formErrors.password ? "invalid-text" : ""}
                >
                  Enter your password
                </Form.Text>
              </Form.Group>
              <Large
                className="btn btn-primary w-100"
                children="Sign In"
                size="mediumbtn"
                variant="primary"
                type="submit"
                buttonWidth="50%"
                isLoading={loading ? "true" : "false"}
                isDisabled={loading ? "true" : "false"}
              />
            </Form>
          </section>
        </Col>
      </Row>
    </Container>
  );
};

export default SignIn;
